import { router } from "@inertiajs/react"
import { UserCheck, UserPlus } from "lucide-react"

import { Button } from "@/components/ui/button"
import { typedPost } from "@/lib/typed-router"
import type { FollowUser } from "@/types/router-mutations"

interface FollowButtonProps {
  userId: number
  isFollowing: boolean
}

export default function FollowButton({
  userId,
  isFollowing,
}: FollowButtonProps) {
  function handleClick() {
    if (isFollowing) {
      router.delete(`/users/${userId}/follows`, { preserveState: true })
    } else {
      typedPost<FollowUser>(
        `/users/${userId}/follows`,
        {},
        { preserveState: true },
      )
    }
  }

  return (
    <Button
      variant={isFollowing ? "outline" : "brand-outline"}
      size="sm"
      onClick={handleClick}
    >
      {isFollowing ? (
        <>
          <UserCheck className="mr-1.5 h-4 w-4" />
          Siguiendo
        </>
      ) : (
        <>
          <UserPlus className="mr-1.5 h-4 w-4" />
          Seguir
        </>
      )}
    </Button>
  )
}
